import script from "./popularSearchCont.vue?vue&type=script&setup=true&lang=js"
export * from "./popularSearchCont.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__